import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import TopHeader from '../template/TopHeader';
import MarketingTopNav from '../marketing/MarketingTopNav';
import { DISCOUNTS_VISIBLE } from '../../config/featureFlags';
import { canManageCodes } from './discountStore';
import DiscountsContent from './DiscountsContent';

// Marketing › Discounts: the page shell (as Journeys and Loyalty); the
// content lives in DiscountsContent.
function DiscountsPage(props) {
  const [addSignal, setAddSignal] = useState(0);
  if (!DISCOUNTS_VISIBLE) return <Redirect to="/marketing-campaigns" />;
  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="discounts">
            {canManageCodes() ? (
              <button type="button" className="catalogue-add-btn" onClick={() => setAddSignal((n) => n + 1)}>Add</button>
            ) : null}
          </MarketingTopNav>
          <div className="catalogue-content-container">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <DiscountsContent addSignal={addSignal} newFor={props.location && props.location.state && props.location.state.newFor} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { user: state.user };
}

export default connect(mapStateToProps)(DiscountsPage);
